import axios from "axios";
import { API_BASE_URL } from "../../config/env";
import { getAuthHeaders } from "../../utils/auth";

const tokenHeaders = () => getAuthHeaders();

export function getGendersCount(params = {}){
    return axios.get(`${API_BASE_URL}api/v1/analytics/demographic`, {
        headers: tokenHeaders(),
        params,
    });
}

export function getMonthlyUsers(params = {}){
    return axios.get(`${API_BASE_URL}api/v1/analytics/monthly-users`, {
        headers: tokenHeaders(),
        params,
    });
}
export function getWeeklyUsers(params = {}){
    return axios.get(`${API_BASE_URL}api/v1/analytics/weekly-users`, {
        headers: tokenHeaders(),
        params,
    });
}

export function getUsersBasedOnGeographic(params = {}){
    return axios.get(`${API_BASE_URL}api/v1/analytics/geographic`, {
        headers: tokenHeaders(),
        params,
    });
}

export function getActiveUsers(params = {}){
    return axios.get(`${API_BASE_URL}api/v1/analytics/active-users`, {
        headers: tokenHeaders(),
        params,
    });
}

export function getHelplineLogs(params = {}){
    return axios.get(`${API_BASE_URL}api/v1/analytics/helpline-logs`, {
        headers: tokenHeaders(),
        params,
    });
}
